import {
  PaymentHistoryFilters,
  PaymentHistoryRow,
  PaymentHistorySource,
} from '../../views/FinancialPortal/PaymentHistory/types';
import { PaymentHistoryDetailResponse } from '../../views/FinancialPortal/shared/payment-history-detail.types';
import { PaymentHubRowResponse } from '../../views/PaymentHub/types';
import { FINANCIAL_PORTAL } from '../endpoints';
import request from '../request';

/**
 * Listado paginado del Historial de Pagos (HU-15462). UNION en backend de
 * CampusCollection (positivo) + cc_refund_charge (negativo).
 */
export function financialPortalPaymentHistory(
  filter: PaymentHistoryFilters & { items: number; page: number },
) {
  const URL = FINANCIAL_PORTAL.PAYMENT_HISTORY_LIST;
  const method = 'GET';
  const params = {
    ...filter,
    items_per_page: filter.items,
  };
  return request<PaymentHubRowResponse<PaymentHistoryRow>>(URL, {
    method,
    params,
  });
}

/**
 * Descarga Excel del Historial de Pagos (HU-15462).
 */
export function financialPortalPaymentHistoryDownload(
  filter: PaymentHistoryFilters,
) {
  const URL = FINANCIAL_PORTAL.PAYMENT_HISTORY_DOWNLOAD;
  const method = 'GET';
  return request(URL, {
    responseType: 'blob',
    method,
    params: filter,
  });
}

/**
 * Listado individual del Historial de Pagos de un estudiante (HU-15469).
 */
export function financialPortalPaymentHistoryByStudent(
  studentId: number,
  filter: PaymentHistoryFilters & { items: number; page: number },
) {
  const URL = FINANCIAL_PORTAL.PAYMENT_HISTORY_BY_STUDENT(studentId);
  const method = 'GET';
  const params = {
    ...filter,
    items_per_page: filter.items,
  };
  return request<PaymentHubRowResponse<PaymentHistoryRow>>(URL, {
    method,
    params,
  });
}

/**
 * Descarga Excel individual del Historial de Pagos (HU-15469).
 */
export function financialPortalPaymentHistoryByStudentDownload(
  studentId: number,
  filter: PaymentHistoryFilters,
) {
  const URL = FINANCIAL_PORTAL.PAYMENT_HISTORY_BY_STUDENT_DOWNLOAD(studentId);
  const method = 'GET';
  return request(URL, {
    responseType: 'blob',
    method,
    params: filter,
  });
}

/**
 * Detalle de un pago recibido (HU-15467) — para el modal "Detalles pago".
 * `source` ∈ collection|refund (compone el id `{source}-{uuid}` del listado).
 */
export function financialPortalPaymentHistoryDetail(
  source: PaymentHistorySource,
  id: string,
) {
  const URL = FINANCIAL_PORTAL.PAYMENT_HISTORY_DETAIL(source, id);
  const method = 'GET';
  return request<PaymentHistoryDetailResponse>(URL, { method });
}
